import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { getCurrentUser } from '../services/authService';

/**
 * ProtectedRoute - Protegge route che richiedono autenticazione
 *
 * @param {Object} props
 * @param {React.Component} props.children - Componente da proteggere
 * @param {boolean} props.requireAdmin - Se true, richiede ruolo admin
 */
function ProtectedRoute({ children, requireAdmin = false }) {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkAuth = async () => {
    try {
      const currentUser = await getCurrentUser();

      if (!currentUser) {
        // Nessun utente autenticato
        setAuthorized(false);
        setLoading(false);
        return;
      }

      // Se richiede admin, verifica il ruolo
      if (requireAdmin) {
        if (currentUser.role === 'admin') {
          setAuthorized(true);
        } else {
          console.warn('⚠️ Access denied: user is not admin');
          setAuthorized(false);
        }
      } else {
        // Solo autenticazione richiesta
        setAuthorized(true);
      }

      setLoading(false);

    } catch (error) {
      console.error('❌ Auth check error:', error);
      setAuthorized(false);
      setLoading(false);
    }
  };

  // Loading state
  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2
        }}
      >
        <CircularProgress />
        <Typography>Verifica autenticazione...</Typography>
      </Box>
    );
  }

  // Not authorized - redirect to login
  if (!authorized) {
    return <Navigate to="/admin/login" replace />;
  }

  // Authorized - render children
  return children;
}

export default ProtectedRoute;
